import React from 'react';
import PropTypes from 'prop-types'; // Import PropTypes

import { Box, Drawer, Grid, Stack } from '@mui/material';
import SeekerOffersFilter from './SeekerOffersFilter';
import SeekerOffersCard from './SeekerOffersCard';
import SeekerOffersCardNF from './SeekerOffersCardNF';

const listings = [
  {
    id: 1,
    login: 'NiteFlirt',
    title: 'New Customers get 3 FREE Minutes',
    photo_url: '/plus_frontend/assets/photo-nf.png',
    rating: null,
    total_ratings: null,
    price_per_minute: null,
    offerTitle: 'Welcome Offer - 3 free minutes',
    offerExpires: 'Expires in 6 days (03/01/25)',
  },
  {
    id: 2,
    login: 'NiteFlirt',
    title: 'Get $10 by converting phone-registered account',
    photo_url: '/plus_frontend/assets/photo-nf.png',
    rating: null,
    total_ratings: null,
    price_per_minute: null,
    offerTitle: 'Web Registration Offer - $10.00',
    offerExpires: 'Expires in 6 days (03/01/25)',
  },
  {
    id: 3,
    login: 'softandsweetkitten',
    title: 'Your Perfect Plaything. New&Already #1 in My Categ',
    photo_url: '/plus_frontend/assets/flirt/ccard/ccard5.jpg',
    rating: 5,
    total_ratings: 24,
    price_per_minute: 2.19,
    offerTitle: 'Flirt Offer - 4 free minutes',
    offerExpires: 'Expires 03/20/25',
  },
  {
    id: 4,
    login: 'Valentina Sophia',
    title: 'Let’s Explore Your Naughty Fantasies',
    photo_url: '/plus_frontend/assets/flirt/ccard/ccard4.jpg',
    rating: 5,
    total_ratings: 501,
    price_per_minute: 1.99,
    offerTitle: 'Flirt Offer - 5 free minutes',
    offerExpires: 'Expires 05/10/25',
  },
];

const SeekerOffersDrawer = ({ open, onClose }) => {
  const list = (
    <Grid container className="drawer-max-width">
      <Grid container className="drawer-hdr">
        <Grid item xs={11}>
          <span className="subhead">Offers & Promotions</span>
        </Grid>
        <Grid item xs={1} className="pull-right">
          <a role="link" tabIndex={0} onClick={onClose} onKeyDown={onClose}>
            <img src="/plus_frontend/assets/svg/x-close.svg" alt="close" />
          </a>
        </Grid>
      </Grid>
      <Box
        className="container-summary-tags"
        sx={{ backgroundColor: 'var(--body_background)', width: '100%', px: 2, py: 1, mb: 1 }}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Box className="row middle-xs start-xs">
            <span role="button" tabIndex={0} className="">All</span>
            <span role="button" tabIndex={0} className="active">Offers</span>
            <span role="button" tabIndex={0} className="">Packages</span>
          </Box>
          <SeekerOffersFilter />
        </Stack>
      </Box>
      <Grid container sx={{ mb: 10, lineHeight: '1.5em' }}>
        <Grid item xs={12} sx={{ mb: 2, mt: 0.25 }}>
          {listings.map((listing) => {
            return listing.price_per_minute !== null ? (
              <SeekerOffersCard key={listing.id} listing={listing} />
            ) : (
              <SeekerOffersCardNF key={listing.id} listing={listing} />
            );
          })}
        </Grid>
      </Grid>
    </Grid>
  );

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      {list}
    </Drawer>
  );
};

SeekerOffersDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SeekerOffersDrawer;
